import Stack from '@mui/material/Stack';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import { useState, useCallback } from 'react';
import ConnectToSfDialog from '../../../../pages/get-started/connect-org/ConnectToSfDialog';
import { CtaDialog } from './CtaDialog';
import usePageblockEvents from '../../../../../hooks/usePageblockEvents';
import WithConnectOrgPermission from '../../../../common/WithConnectOrgPermission';

interface HeaderWithConnectToSfButtonsProps {
  headerText: string;
  subHeaderText: string;
  imgSrc: string;
  imgAlt: string;
  name: string;
}

export const PageHeaderWithConnectToSfButtons = ({
  headerText,
  subHeaderText,
  imgSrc,
  imgAlt,
  name,
}: HeaderWithConnectToSfButtonsProps) => {
  const { sendOpenCtaDialogEvent, sendConnectSfClickEvent } = usePageblockEvents();
  const [isConnectToSfDialogOpen, setIsConnectToSfDialogOpen] = useState(false);
  const [isCtaDialogOpen, setIsCtaDialogOpen] = useState(false);

  const openConnectToSfDialog = () => {
    setIsConnectToSfDialogOpen(true);
  };

  const closeConnectToSfDialog = useCallback(() => {
    setIsConnectToSfDialogOpen(false);
  }, []);

  return (
    <Stack
      direction="row"
      sx={{
        background: colors.grey[100],
        p: '64px 102px',
        alignItems: 'center',
        width: '100%',
      }}
      justifyContent="center"
    >
      {isConnectToSfDialogOpen && (
        <ConnectToSfDialog
          closeDialog={closeConnectToSfDialog}
          forceProduction={false}
          onFinish={closeConnectToSfDialog}
        />
      )}

      {isCtaDialogOpen && (
        <CtaDialog name={name} onClose={() => setIsCtaDialogOpen(false)} />
      )}

      <Stack direction="row" sx={{ width: '1080px', gap: 16 }} justifyContent="space-between">
        <Stack gap={4}>
          <Stack gap={1}>
            <Typography variant="h1-medium" color={colors.night[900]}>
              {headerText}
            </Typography>
            <Typography variant="body" color={colors.night[900]}>
              {subHeaderText}
            </Typography>
          </Stack>

          <Stack width="448px">
            <Typography variant="caption-medium" color={colors.night[900]}>
              Ready to try it out?
            </Typography>
            <Stack direction="row" gap={2} pt={1}>
              <WithConnectOrgPermission>
                <Button
                  size="medium"
                  onClick={() => {
                    sendConnectSfClickEvent();
                    openConnectToSfDialog();
                  }}
                >
                  Connect to Salesforce
                </Button>
              </WithConnectOrgPermission>
              <Button
                size="medium"
                variant="system"
                onClick={() => {
                  sendOpenCtaDialogEvent();
                  setIsCtaDialogOpen(true);
                }}
              >
                Talk to an expert
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <img src={imgSrc} alt={imgAlt} style={{ height: '100%', width: '436px' }} />
      </Stack>
    </Stack>
  );
};
